/**
 * Phase 10D: Register service worker for PWA.
 */
export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  const swUrl = (process.env.PUBLIC_URL || '') + '/custom-sw.js';
  navigator.serviceWorker.register(swUrl).then((reg) => {
    reg.onupdatefound = () => {
      const w = reg.installing;
      if (!w) return;
      w.onstatechange = () => {
        if (w.state === 'installed' && navigator.serviceWorker.controller) config?.onUpdate?.(reg);
        else if (w.state === 'installed') config?.onSuccess?.(reg);
      };
    };
  }).catch(() => {});
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then((r) => r.unregister());
}
